import { useRouterHistory } from 'react-router';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import { syncHistoryWithStore, HistoryUnsubscribe } from 'react-router-redux';
import { History } from 'history';
import { parse, stringify } from 'qs';
import store from '../redux/store';

// eslint-disable-next-line react-hooks/rules-of-hooks
const createAppHistory = useRouterHistory(createBrowserHistory);
const appHistory = createAppHistory({
  parseQueryString: parse,
  stringifyQuery: stringify,
});

export const history: History & HistoryUnsubscribe = syncHistoryWithStore(
  appHistory,
  store
);

export default history;
